import { Box, useClassNames } from '@factorialco/deprecated-design-system'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { Moment } from 'moment'

import EmployeeCellContent, {
  EmployeeCellContentType,
} from 'modules/project_management/components/Schedule/Body/ScheduleItem/HeaderRow/EmployeeCellContent'
import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { gridColumnsVar } from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'

import { RowType } from '../types'
import { getBackgroundColor, sumMinutesForDate } from '../utils'
import HeaderCell from './HeaderCell'

interface IHeaderRowProps {
  days: Moment[]
  dataHeaderRow: EmployeeCellContentType
  rows: RowType[]
  toggle: () => void
  open: boolean
  isChevronHidden: boolean
}

interface GroupedCell {
  value: number
  span: number
}

const HeaderRow = ({
  days,
  dataHeaderRow,
  rows,
  toggle,
  open,
  isChevronHidden = false,
}: IHeaderRowProps) => {
  const cx = useClassNames(stylesRefs)

  const generateHeaderCells = (): number[] => {
    const records =
      rows.flatMap((row) => {
        return Object.values(row.records).flat()
      }) ?? []
    return days.map((day) => sumMinutesForDate(day, records))
  }

  const groupHeaderCells = (cells: number[]) => {
    return cells.reduce<GroupedCell[]>((acc, current, index) => {
      if (current === 0) {
        acc.push({ value: 0, span: 1 })
      } else if (index > 0 && current === cells[index - 1] && cells[index - 1] !== 0) {
        const lastCell = acc[acc.length - 1]
        if (lastCell) {
          lastCell.span += 1
        }
      } else {
        acc.push({ value: current, span: 1 })
      }
      return acc
    }, [])
  }

  const headerCells = generateHeaderCells()
  const groupedCells = groupHeaderCells(headerCells)
  const totalCells = days.length

  return (
    <Box
      className={cx('scheduleItemRow')}
      border={
        open
          ? {
              top: {
                color: 'grey300',
                width: 's1',
                style: 'solid',
              },
              bottom: { color: 'grey300', width: 's1', style: 'solid' },
            }
          : undefined
      }
    >
      <Box className={cx('scheduleItemFirstColumn')} onClick={toggle}>
        <EmployeeCellContent
          employee={dataHeaderRow}
          open={open}
          isChevronHidden={isChevronHidden}
        />
      </Box>
      <Box
        onClick={toggle}
        className={cx('scheduleItemDateContainer')}
        style={assignInlineVars({
          [gridColumnsVar]: totalCells.toString(),
        })}
      >
        {groupedCells.map((cell, index) => (
          <HeaderCell key={index} value={cell.value} span={cell.span} />
        ))}
        <Box
          className={cx('gridOverlay')}
          style={assignInlineVars({
            [gridColumnsVar]: totalCells.toString(),
          })}
        >
          {Array.from({ length: totalCells }).map((_, i) => (
            <Box key={i} background={getBackgroundColor(i, days)} className={cx('gridLine')} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default HeaderRow
